import { PHPBlog } from "./PHPBlog";
import "./index.css";

export function App() {
  return (
    <div className="min-h-screen bg-background">
      <header className="border-b bg-card/50 backdrop-blur">
        <div className="container mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-primary rounded-lg flex items-center justify-center">
                <span className="text-primary-foreground font-bold text-lg">PHP</span>
              </div>
              <div>
                <h1 className="text-xl font-bold text-foreground">编程经验分享</h1>
                <p className="text-sm text-muted-foreground">个人技术感悟</p>
              </div>
            </div>
            {/* <nav className="flex gap-6">
              <a href="#" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                首页
              </a>
              <a href="#" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                文章
              </a>
              <a href="#" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                关于
              </a>
            </nav> */}
          </div>
        </div>
      </header>

      <main className="container mx-auto px-4 py-8">
        <PHPBlog />
      </main>

      <footer className="border-t bg-card/50 mt-16">
        <div className="container mx-auto px-4 py-8">
          <div className="text-center text-muted-foreground">
            <p className="mb-2">© 2024 编程经验分享 - 个人技术感悟</p>
            <p className="text-sm">
              专注于PHP开发技术分享，传播编程知识与实践
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
